import { Button, Group, NumberInput, Stack } from '@mantine/core';
import { useState } from 'react';
import { Currency, DepositProvider, type NewDepositHttp } from '@/api';
import { useRustyState } from '../../state';

export interface NewDepositFormProps {
  onCancelCb: () => void;
}

export function NewDepositForm({ onCancelCb }: NewDepositFormProps) {
  const { api } = useRustyState.getState();
  const [isBusy, setIsBusy] = useState(false);
  const [amount, setAmount] = useState(15.0);

  const startDeposit = async () => {
    setIsBusy(true);
    try {
      const newDeposit: NewDepositHttp = {
        amount: Math.round(amount * 100), // Convert to cents
        currency: Currency.EUR,
        provider: DepositProvider.STRIPE,
      };
      const res = await api.newDeposit(newDeposit);
      if (!res) {
        throw new Error('Failed to start deposit: Could not create deposit.');
      }

      if (res.type === 'STRIPE') {
        // Redirect to Stripe checkout using URL from backend
        window.location.href = res.content.checkout_url;
      }
    } catch (e) {
      console.error(e);
    }
    setIsBusy(false);
  };

  return (
    <Stack>
      <NumberInput
        label="Amount (EUR)"
        prefix="€"
        maw={300}
        mb="xs"
        allowNegative={false}
        allowLeadingZeros={false}
        allowDecimal={true}
        step={0.01}
        decimalScale={2}
        min={0.01}
        value={amount}
        onChange={(e) => setAmount(e as number)}
      />

      <Group>
        <Button loading={isBusy} onClick={startDeposit} variant="filled">
          Pay with Stripe
        </Button>
        <Button variant="light" onClick={onCancelCb}>
          Cancel
        </Button>
      </Group>
    </Stack>
  );
}
